import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import { getUser } from "../api/User";
import { useAlert } from "../hook/useAlert";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { onInfo } = useAlert();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const userData = await getUser();
      setUser(userData);
    } catch (error) {
      onInfo("Failed to fetch user:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const contextValue = useMemo(
    () => ({
      user,
      loading,
      refetchUser: fetchUser,
    }),
    [user, loading, fetchUser]
  );

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  return context;
};
